import { faFileInvoice } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  FlexRow,
  Grid,
  Header4Text,
  HeaderShadowWrapper,
  SmallBodyText,
  SpaceWrapper,
  TextTag,
  Tooltip,
} from 'ui-toolkit';
import { OrderNavigation } from './OrderNavigation';
import { copyAddressToClipboard } from '../../../utilities/order/header/copyAddressToClipboard';
import { TinyToolTipText } from './TinyToolTipText';
import { CursorFlexRow } from './CursorFlexRow';
import { HeaderInformationRow } from './HeaderInformationRow';
import { FeesDetailsHeader } from './FeesDetailsHeader';
import { OrderTabs } from 'store/order/orderNavigation/orderNavigationSlice';
import { DisplayTransactionCategory, eTransactionCategory } from '../../../ui-toolkit/enums/eTransactionType';
import { IOrderDetailsData } from '../../../ui-toolkit/orders/interfaces/IOrderDetailsData';
import { useHasFeatureFlag } from '../../../selectors/useHasFeatureFlag';
import { ZimTag } from '../overview/Summary/partiesTab/ZimTag';

const RoomyGrid = styled(Grid)`
  gap: ${(props) => props.theme.spacing.spacing3};
`;

const StickyNavigation = styled.div<{ isVisible: boolean }>`
  display: ${(props) => (props.isVisible ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 15;
`;

const StyledOverflowGrid = styled(Grid)`
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

export interface IStickyOrderHeaderProps {
  order: IOrderDetailsData;
  activeTab?: string;
}

export const StickyOrderHeader: React.FC<IStickyOrderHeaderProps> = ({ order, activeTab }) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 220) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const orderId = order.transaction.id!;

  return (
    <StickyNavigation isVisible={isVisible}>
      <HeaderShadowWrapper useDefaultBackground={isZillowClosingEnabled}>
        <SpaceWrapper bottomSpace={'none'}>
          <StyledOverflowGrid columnCount={2} templateColumns={`auto min-content`}>
            <RoomyGrid>
              <FlexRow justifyContent={'space-between'}>
                <Grid columnCount={7} columnWidth={`max-content`} textAlign={'center'} alignItems={'center'}>
                  <SmallBodyText>
                    <FontAwesomeIcon icon={faFileInvoice} />
                  </SmallBodyText>
                  <SmallBodyText>{order.transaction.file_number}</SmallBodyText>
                  <TextTag
                    text={DisplayTransactionCategory[order.transaction.transaction_category]}
                    type={order.transaction.transaction_category === eTransactionCategory.Purchase ? 'blue' : 'yellow'}
                  />
                  <ZimTag />
                  <CursorFlexRow>
                    <Tooltip
                      tooltipContent={<TinyToolTipText message={'Click to copy full address'} />}
                      placement={'bottom'}
                      trigger={'hover'}
                    >
                      <Header4Text onClick={() => copyAddressToClipboard(order.property)}>
                        {order.property.street_address} {order.property.unit}
                      </Header4Text>
                    </Tooltip>
                  </CursorFlexRow>
                </Grid>
              </FlexRow>
              <HeaderInformationRow order={order} />
              <div>
                <OrderNavigation orderId={orderId} />
                {activeTab === OrderTabs.Fees && <FeesDetailsHeader orderId={orderId} />}
              </div>
            </RoomyGrid>
          </StyledOverflowGrid>
        </SpaceWrapper>
      </HeaderShadowWrapper>
    </StickyNavigation>
  );
};
